import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Seo } from "../lib/seo";
import { MaskText, Reveal } from "../lib/motion";
import { ProjectFrame } from "./Home";
import { PROJECTS } from "../data/site";

export default function Projekt() {
  const gallery = PROJECTS;
  const spans = [
    "md:col-span-6 aspect-[4/3]",
    "md:col-span-6 aspect-[4/3]",
    "md:col-span-4 aspect-[3/4]",
    "md:col-span-4 aspect-[3/4]",
    "md:col-span-4 aspect-[3/4]",
    "md:col-span-7 aspect-[16/10]",
    "md:col-span-5 aspect-[16/10]",
  ];

  return (
    <>
      <Seo
        title="Projekt · Casagon Bygg & Allservice"
        description="Se ett urval av Casagons utförda arbeten inom golvläggning, kök, renovering och bygg. Casagon tar uppdrag i hela Skåne och hela Göteborg."
        path="/projekt"
      />

      {/* Hero */}
      <section className="bg-warmwhite pb-10 pt-32 md:pb-12 md:pt-40" data-testid="projekt-hero">
        <div className="u-container">
          <Reveal>
            <p className="overline text-wood">
              <span className="mr-2 inline-block h-2 w-2 bg-casared align-middle" />
              Portfölj
            </p>
          </Reveal>
          <MaskText
            as="h1"
            animateOnLoad
            delay={0.15}
            lines={["Utförda projekt"]}
            className="mt-6 font-display font-bold leading-[0.95] tracking-tight text-[8vw] sm:text-6xl lg:text-7xl"
          />
          <Reveal delay={0.3}>
            <p className="mt-8 max-w-xl text-base leading-relaxed text-graphite/70 md:text-lg">
              Ett urval av golv-, bygg- och renoveringsarbeten utförda av Casagon. Vi tar uppdrag i
              hela Skåne och hela Göteborg.
            </p>
          </Reveal>
        </div>
      </section>


      {/* Curated gallery */}
      <section className="bg-warmwhite pb-16 pt-8 md:pb-20 md:pt-10" data-testid="projekt-gallery">
        <div className="u-container">
          <MaskText as="h2" lines={["Utvalda arbeten"]} className="font-display text-4xl font-bold tracking-tight sm:text-5xl" />
          <div className="mt-12 grid grid-cols-1 gap-5 md:grid-cols-12">
            {gallery.map((p, i) => (
              <ProjectFrame key={p.id} project={p} className={spans[i % spans.length]} big={i === 0 || i === 5} />
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="bg-paper py-16 md:py-20" data-testid="projekt-cta">
        <div className="u-container flex flex-col items-start justify-between gap-8 md:flex-row md:items-center">
          <MaskText as="h2" lines={["Har du ett projekt på gång?"]} className="font-display text-3xl font-bold tracking-tight sm:text-5xl" />
          <Link
            to="/kontakt"
            data-testid="projekt-quote-cta"
            className="group inline-flex items-center gap-3 bg-graphite px-8 py-4 text-xs font-bold uppercase tracking-[0.2em] text-warmwhite transition-colors duration-300 hover:bg-casared"
          >
            Begär offert <ArrowUpRight size={16} className="transition-transform duration-300 group-hover:translate-x-1" />
          </Link>
        </div>
      </section>
    </>
  );
}
